import { render, staticRenderFns } from "./editcustomershopaddress.vue?vue&type=template&id=45b8a3b9"
import script from "./editcustomershopaddress.vue?vue&type=script&lang=js"
export * from "./editcustomershopaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports